import BotInboundNavbar from './BotInboundNavbar'

export default BotInboundNavbar;